import React from "react";

// NEW pages (you will create these)
import StudioPackages from "./StudioPackages";
import WeddingPackages from "./WeddingPackages";
import StudioRentals from "./StudioRentals";
import StudioBookings from "./StudioBookings";
import WeddingPackageBookings from "./WeddingPackageBookings";
import StudioRentalBookings from "./StudioRentalBookings";
import Reviews from "./Reviews";

const handleDragOver = (e) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = "move";
};

const MainContent = ({
  activeTab,
  setIsSidebarOpen,
}) => {
  return (
    <main
      className="min-w-0 flex-1 max-h-screen overflow-x-auto overflow-y-hidden"
      onDragOver={(e) => handleDragOver(e)}
    >
      <div className="flex h-full min-h-0 flex-col p-4 sm:p-6 lg:p-8">
        {/* Mobile menu button */}
        <div className="mb-4 shrink-0 lg:hidden">
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white shadow"
          >
            ☰ Menu
          </button>
        </div>

        {/* Page container */}
        <div className="flex-1 min-h-0">

          {activeTab === "studio-packages" && <StudioPackages />}

          {activeTab === "wedding-packages" && <WeddingPackages />}

          {activeTab === "studio-rentals" && <StudioRentals />}

          {activeTab === "studio-bookings" && <StudioBookings />}

          {activeTab === "wedding-bookings" && <WeddingPackageBookings />}

          {activeTab === "studio-rental-bookings" && <StudioRentalBookings />}

          {activeTab === "reviews" && <Reviews />}

        </div>
      </div>
    </main>
  );
};

export default MainContent;